import { fetchOrchidAPI } from "utils/api";

export default function putOrchidProProfileImg(imageData) {
  return fetchOrchidAPI("/api/users/orchid_pro/profile_image", {
    method: "PUT",
    body: imageData,
  }).then((response) => {
    if (response.ok) {
      return response;
    } else {
      throw Error(JSON.stringify(response.statusText) || "Error");
    }
  });
}
